// Removes 'px' from variable string, and converts to an integer
export const parseStyleVar = styleVar => parseInt(styleVar.replace('px', ''));

// Sums an array of style variables
export const sumStyleVars = (...styleVars) =>
  styleVars.map(parseStyleVar).reduce((acc, sv) => acc + sv);
